module.exports = __webpack_public_path__ + "img/view.6d32df1b.svg";